(() => {
  const ELEMENT_NAME = "variant-product-video";
  const MAIN_PRODUCT_FORM_PREFIX = "product-form-main-";

  class VariantProductVideo extends HTMLElement {
    connectedCallback() {
      this.handleVariantChange = this.handleVariantChange.bind(this);
      document.addEventListener("variant:change", this.handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener("variant:change", this.handleVariantChange);
    }

    handleVariantChange(event) {
      const { variant } = event.detail || {};
      const formId = event.target?.getAttribute?.("id");

      if (!formId?.startsWith(MAIN_PRODUCT_FORM_PREFIX) || !variant?.id) {
        return;
      }

      const variantId = String(variant.id);
      const template = Array.from(
        this.querySelectorAll("template[data-variant-id]")
      ).find((candidate) => candidate.dataset.variantId === variantId);
      const content = this.querySelector(
        "[data-variant-product-video-content]"
      );

      if (!template || !content) {
        return;
      }

      const hasVideo = template.dataset.hasVideo === "true";

      content.replaceChildren(template.content.cloneNode(true));
      content.hidden = !hasVideo;
      this.hidden = !hasVideo;
    }
  }

  if (!window.customElements.get(ELEMENT_NAME)) {
    window.customElements.define(ELEMENT_NAME, VariantProductVideo);
  }
})();
